import React from 'react';
import { motion } from 'framer-motion';
export function BenefitsSection() {
  return <section className="py-12 md:py-24 bg-earth-darkGreen relative overflow-hidden" data-id="element-11">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full opacity-10 pointer-events-none" data-id="element-12">
        <div className="absolute -top-24 -left-24 w-96 h-96 rounded-full bg-earth-green blur-3xl" data-id="element-13"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 rounded-full bg-earth-amber blur-3xl" data-id="element-14"></div>
      </div>

      <div className="container mx-auto px-6 relative z-10 text-center max-w-4xl" data-id="element-15">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-8" data-id="element-17">
            Control total sobre lo que come tu mascota
          </h2>
          <p className="text-xl text-gray-200 mb-10 font-light leading-relaxed" data-id="element-18">
            Y sí, incluye todo lo que necesitas para hacerlo bien: recetas,
            estructura, lógica y sentido común aplicado a la alimentación real.
            Logrando una alimentación más natural sin aumentar el gasto mensual,
            e incluso reduciéndolo frente a opciones comerciales premium.
          </p>

          <div className="inline-block bg-dark-900/50 backdrop-blur-sm border border-earth-green/30 rounded-xl p-6" data-id="element-19">
            <p className="text-lg font-semibold text-earth-amber uppercase tracking-wider" data-id="element-20">
              Variedad • Seguridad • Criterio
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}